<div class="bar theme-bg theme-bg-2" [class.is-panel]="mode() === 'panel'" role="dialog" [attr.aria-modal]="mode() === 'panel' ? 'true' : null"
  aria-labelledby="cookies-bar-title" aria-describedby="cookies-bar-content">
  <div class="left">
    <!-- Icono a todo color (no monocromo): app-icon (SVG inline currentColor) no
    aplica aquí, se deja como <img> nativo — mismo coste ~0 en hidratación que
    ion-icon->app-icon buscaba evitar, sin depender del registro de app-icon. -->
    <img src="/assets/icons/new_design/cookie_anim.svg" alt="">
  </div>
  <div class="right">
    <div class="title theme-text theme-title-0" id="cookies-bar-title">Cookies</div>

    <div class="content theme-text theme-title-2" id="cookies-bar-content">Usamos cookies propias y de terceros para
      que la web funcione, para analizar el tráfico y para personalizar el contenido y los anuncios. Puedes aceptarlas
      todas, rechazarlas todas o elegir por finalidad. Las cookies técnicas son imprescindibles y no se pueden
      desactivar; el resto no se activa hasta que tú lo decidas, y puedes cambiar de opinión cuando quieras desde la
    política de cookies.</div>

    @if (showPrefs()) {
      <div class="prefs">
        <div class="pref">
          <div class="pref-text">
            <div class="pref-title theme-text theme-title-0">Técnicas</div>
            <div class="pref-desc theme-text theme-title-2">Imprescindibles para que la web funcione y para mantener tu
            sesión. No se pueden desactivar.</div>
          </div>
          <ion-toggle [checked]="true" [disabled]="true" aria-label="Cookies técnicas, siempre activas"></ion-toggle>
        </div>
        <div class="pref">
          <div class="pref-text">
            <div class="pref-title theme-text theme-title-0">Analítica</div>
            <div class="pref-desc theme-text theme-title-2">Nos permiten saber qué chollos y qué páginas interesan, para
            mejorar la web (Google Analytics).</div>
          </div>
          <ion-toggle [(ngModel)]="prefs.analytics" [ngModelOptions]="{standalone: true}"
          aria-label="Cookies analíticas"></ion-toggle>
        </div>
        <div class="pref">
          <div class="pref-text">
            <div class="pref-title theme-text theme-title-0">Publicidad</div>
            <div class="pref-desc theme-text theme-title-2">Permiten medir el rendimiento de las campañas y de los enlaces
            a las tiendas (Google Ads, Meta).</div>
          </div>
          <ion-toggle [(ngModel)]="prefs.ads" [ngModelOptions]="{standalone: true}"
          aria-label="Cookies publicitarias"></ion-toggle>
        </div>
        <div class="pref">
          <div class="pref-text">
            <div class="pref-title theme-text theme-title-0">Personalización</div>
            <div class="pref-desc theme-text theme-title-2">Sirven para adaptar los anuncios que ves a tus intereses.</div>
          </div>
          <ion-toggle [(ngModel)]="prefs.personalization" [ngModelOptions]="{standalone: true}"
          aria-label="Cookies de personalización"></ion-toggle>
        </div>
      </div>
    }

    <div class="links theme-text theme-title-2">
      <a class="invisible" appGoToUrl href="/politica-de-privacidad/">Política de privacidad</a>
      <a class="invisible" appGoToUrl href="/politica-de-cookies/">Política sobre cookies</a>
    </div>

    <div class="buttons">
      <button type="button" class="btn-primary mc-btn" (click)="rejectAll()">Rechazar todo</button>
      <button type="button" class="btn-primary mc-btn" (click)="acceptAll()">Aceptar todo</button>
      @if (!showPrefs()) {
        <button type="button" class="btn-secondary mc-btn" (click)="showPrefs.set(true)">Configurar</button>
      }
      @if (showPrefs()) {
        <button type="button" class="btn-secondary mc-btn" (click)="saveSelection()">Guardar selección</button>
      }
    </div>
  </div>
</div>
